<div class="content-wrapper p-0">
	<div class="content-body">
		<app-content-header [contentHeader]="contentHeader"></app-content-header>
		<section class="app-ecommerce-details">
			<div class="card">
				<div class="bs-stepper horizontal-wizard-example">
					<div class="bs-stepper-header">
						<b>Bank Details</b>
					</div>
					<div class="bs-stepper-content">
						<div class="card-body">
							<div class="users-list-filter">
								<form [formGroup]="bankdetailsform" autocomplete="off">
									<fieldset class="border" style="padding: 0.7rem;">
										<legend class="w-auto">
											<h5 style="margin-top: 7px;">Details of Account Holder </h5>
										</legend>
										<div class="row">
											<div class="form-group col-md-4">
												<label class="form-label" for="accountHolderName">Name of the Account Holder</label>
												<span class="required-asterisk">*</span>
												<input formControlName="accountHolderName" type="text"
													name="accountHolderName" id="accountHolderName" class="form-control"
													placeholder="Account Holder Name"
													[ngClass]="{ 'is-invalid': submitted && !bankFormData.accountHolderName.valid }" />
												<span *ngIf="submitted && bankFormData.accountHolderName.invalid"
													class="invalid-form">
													<small class="form-text text-danger"
														*ngIf="bankFormData.accountHolderName.errors.required">This
														field is required!</small>
													<small class="form-text text-danger"
														*ngIf="bankFormData.accountHolderName.errors.pattern">This field contain atleast one alphanumerical value!</small>
												</span>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label" for="contactAddress">Complete Contact Address</label>
												<input formControlName="completeAddress" type="text" id="contactAddress" class="form-control" placeholder="Contact Address"
												[ngClass]="{ 'is-invalid': submitted && !bankFormData.completeAddress.valid }" />
												<span *ngIf="submitted && bankFormData.completeAddress.invalid" class="invalid-form">
													<small class="form-text text-danger"
													*ngIf="bankFormData.completeAddress.errors.pattern">This field contain atleast one alphanumerical value!</small>
												</span>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label" for="telephoneNo">Telephone No.</label>
												<input formControlName="telephoneNo" type="text" name="telephoneNo"
													id="telephoneNo" class="form-control" placeholder="Telephone No." [mask]="'^([1-9]\\d*|0)$'" maxlength="11"/>
											</div>
										</div>
										<div class="row">
											<div class="form-group col-md-4">
												<label class="form-label" for="faxno">Fax No.</label>
												<input formControlName="faxNo" type="text" name="faxno" id="faxno"
													class="form-control" placeholder="Fax No." [mask]="'^([1-9]\\d*|0)$'" maxlength="22"/>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label" for="emailId">Email</label>
												<input formControlName="email" type="text" name="emailId" id="emailId"
													class="form-control" placeholder="Email ID" [ngClass]="{ 'is-invalid': submitted && !bankFormData.email.valid }"/>
												<span *ngIf="submitted && bankFormData.email.invalid" class="invalid-form">
													<small class="form-text text-danger"
													*ngIf="bankFormData.email.errors.email">Please enter valid email Id.</small>
												</span>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label" for="pan">Pan</label>
												<input formControlName="pan" type="text" name="pan" id="pan" class="form-control panUpperCase" placeholder="Pan No." [ngClass]="{ 'is-invalid': submitted && !bankFormData.pan.valid }"/>
												<span *ngIf="submitted && bankFormData.pan.invalid" class="invalid-form">
													<small class="form-text text-danger"
													*ngIf="bankFormData.pan.errors.pattern">Please enter valid pan card number</small>
												</span>
											</div>
										</div>
										<div class="row">
											<div class="form-group col-md-4">
												<label class="form-label" for="tin">Tin</label>
												<div class="demo-inline-spacing" style="margin-top: -15px;">
													<div class="custom-control custom-radio"
														*ngFor="let a of tinDetails; let $index=index">
														<input type="radio" id="isTinApplicable{{$index}}"
															formControlName="isTinApplicable" name="isTinApplicable"
															class="custom-control-input" value="{{a.tinID}}"
															(change)='onOptionsSelected(a.tinID)' />
														<label class="custom-control-label"
															for="isTinApplicable{{$index}}">{{a.tinName}}</label>
													</div>
												</div>
											</div>
											<div class="form-group col-md-4" *ngIf="displayField">
												<label class="form-label" for="tin">Tin Number</label>
												<input formControlName="tinNumber" type="text" name="tinNumber"
													id="tinNumber" class="form-control" placeholder="Tin Number" />
											</div>
										</div>
									</fieldset>
									<fieldset class="border" style="padding: 0.7rem;">
										<legend class="w-auto">
											<h5 style="margin-top: 7px;">Bank Account Details </h5>
										</legend>
										<div class="row">
											<div class="form-group col-md-4">
												<label class="form-label" for="nameOfBank">Name of the
													Bank</label>
												<span class="required-asterisk">*</span>
												<input formControlName="nameOfBank" type="text" name="nameOfBank"
													id="nameOfBank" class="form-control" placeholder="Name of the Bank"
													[ngClass]="{ 'is-invalid': submitted && !bankFormData.nameOfBank.valid }" />
												<span *ngIf="submitted && bankFormData.nameOfBank.invalid"
													class="invalid-form">
													<small class="form-text text-danger"
														*ngIf="bankFormData.nameOfBank.errors.required">This field
														is required!</small>
													<small class="form-text text-danger"
														*ngIf="bankFormData.nameOfBank.errors.pattern">This field contain atleast one alphanumerical value!</small>
												</span>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label" for="addressOfBank">Name and Address of the
													Bank/Branch</label>
												<input formControlName="addressOfBank" type="text" name="branchNameAdd"
													id="addressOfBank" class="form-control"
													placeholder="Name And Address of the Branch" [ngClass]="{ 'is-invalid': submitted && !bankFormData.addressOfBank.valid }"/>
												<span *ngIf="submitted && bankFormData.addressOfBank.invalid"
													class="invalid-form">
													<small class="form-text text-danger"
														*ngIf="bankFormData.addressOfBank.errors.pattern">This field contain atleast one alphanumerical value!</small>
												</span>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label" for="completeAccountNumber">Complete Bank
													Account
													Number</label>
												<span class="required-asterisk">*</span>
												<input formControlName="completeAccountNumber" type="text"
													name="completeAccountNumber" id="completeAccountNumber"
													class="form-control" placeholder="Bank Account Number"
													[ngClass]="{ 'is-invalid': submitted && !bankFormData.completeAccountNumber.valid }" [mask]="'^([1-9]\\d*|0)$'"/>
												<span *ngIf="submitted && bankFormData.completeAccountNumber.invalid"
													class="invalid-form">
													<small class="form-text text-danger"
														*ngIf="bankFormData.completeAccountNumber.errors.required">This
														field
														is required!</small>
												</span>
											</div>
										</div>
										<div class="row">
											<div class="form-group col-md-4">
												<label class="form-label" for="bankEmail">Emai ID</label>
												<input formControlName="bankEmail" type="text" name="bankEmail"
													id="bankEmail" class="form-control" placeholder="Email ID" [ngClass]="{ 'is-invalid': submitted && !bankFormData.bankEmail.valid }"/>
												<span *ngIf="submitted && bankFormData.bankEmail.invalid" class="invalid-form">
													<small class="form-text text-danger" *ngIf="bankFormData.bankEmail.errors.email">Please Enter valid email Id. </small>
												</span>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label" for="nameOfBeneficiary">Name of the Beneficiary</label>
												<input formControlName="nameOfBeneficiary" type="text"
													name="nameOfBeneficiary" id="nameOfBeneficiary" class="form-control"
													placeholder="Name of the Beneficiary" [ngClass]="{ 'is-invalid': submitted && !bankFormData.nameOfBeneficiary.valid }"/>
												<span *ngIf="submitted && bankFormData.nameOfBeneficiary.invalid" class="invalid-form">
													<small class="form-text text-danger" *ngIf="bankFormData.nameOfBeneficiary.errors.pattern">This field contain atleast one alphanumerical value! </small>
												</span>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label" for="ifscCode">IFSC Code</label>
												<span class="required-asterisk">*</span>
												<input formControlName="ifscCode" type="text" name="ifscCode"
													id="ifscCode" class="form-control" placeholder="IFSC code"
													[ngClass]="{ 'is-invalid': submitted && !bankFormData.ifscCode.valid }" />
												<span *ngIf="submitted && bankFormData.ifscCode.invalid"
													class="invalid-form">
													<small class="form-text text-danger"
														*ngIf="bankFormData.ifscCode.errors.required">This field
														is required!</small>
													<small class="form-text text-danger"
														*ngIf="bankFormData.ifscCode.errors.pattern">This field contain atleast one alphanumerical value!</small>
												</span>
											</div>
										</div>
										<div class="row">
											<div class="form-group col-md-4">
												<label class="form-label" for="micrCode">MICR Code</label>
												<input formControlName="micrCode" type="text" name="micrCode"
													id="micrCode" class="form-control" placeholder="MICR code" [ngClass]="{ 'is-invalid': submitted && !bankFormData.micrCode.valid }"/>
												<span *ngIf="submitted && bankFormData.micrCode.invalid"
													class="invalid-form">
													<small class="form-text text-danger"
														*ngIf="bankFormData.micrCode.errors.pattern">This field contain atleast one alphanumerical value!</small>
												</span>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label" for="tin">IBAN Account Number</label>
												<input formControlName="ibanAccountNumber" type="text"
													name="ibanAccountNumber" id="ibanAccountNumber" class="form-control"
													placeholder="IBAN Account Number" [ngClass]="{ 'is-invalid': submitted && !bankFormData.ibanAccountNumber.valid }"/>
												<span *ngIf="submitted && bankFormData.ibanAccountNumber.invalid"
													class="invalid-form">
													<small class="form-text text-danger"
														*ngIf="bankFormData.ibanAccountNumber.errors.pattern">This field contain atleast one alphanumerical value!</small>
												</span>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label" for="bankTelephoneNo">Telephone No.</label>
												<input formControlName="bankTelephoneNo" type="text"
													name="bankTelephoneNo" id="bankTelephoneNo" class="form-control"
													placeholder="Telephone No."  [mask]="'^([1-9]\\d*|0)$'" maxlength="11"/>
											</div>
										</div>
										<div class="row">
											<div class="form-group col-md-4">
												<label class="form-label" for="bicSwiftCode">BIC/Swift Code</label>
												<input formControlName="bicSwiftCode" type="text" name="bicSwiftCode"
													id="bicSwiftCode" class="form-control"
													placeholder="BIC/Swift Code" [ngClass]="{ 'is-invalid': submitted && !bankFormData.bicSwiftCode.valid }"/>
												<span *ngIf="submitted && bankFormData.bicSwiftCode.invalid"
													class="invalid-form">
													<small class="form-text text-danger"
														*ngIf="bankFormData.bicSwiftCode.errors.pattern">This field contain atleast one alphanumerical value!</small>
												</span>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label" for="typeOfBankAccount">Type of Bank
													Account</label>
												<ng-select [items]="bankAccountTypes" bindLabel="name" bindValue="id"
													formControlName="typeOfBankAccount" placeholder="Select A/C type"
													[(ngModel)]="bankAccountTypeSelected">
												</ng-select>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label custom-control-inline" for="cancelCheck">Upload
													Cancel Check</label>(Upload PDF, image(jpeg or png) of size upto 25MB)
												<div class="custom-file" [ngClass]="{ 'customUploadCls': uploadCancelChequeUrl }">
													<input type="file" class="custom-file-input" ng2FileSelect
														id="file-upload-single" accept="image/jpeg, image/png, application/pdf"
														(click)="browsbuttonClick('cancelCheck')"
														(change)="onFileChange($event, 'cancelCheck', 25)" />
													<label class="custom-file-label" id="cancelCheck"
														for="file-upload-single">{{bankFormData.cancelCheckName.value}}</label>

												</div>
												<div *ngIf="uploadCancelChequeUrl" class="download-file">
													<a href="{{uploadCancelChequeUrl}}" target="_blank"><i
															class="custom-control-inline feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i></a>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="form-group col-md-4"
												*ngIf="bankFormData.isBondUpload.value == 1">
												<label class="form-label" for="uploadBoand">Upload Boand</label>(Upload PDF, image(jpeg or png) of size upto 25MB)
												<div class="custom-file" [ngClass]="{ 'customUploadCls': bondDocumentUrl }">
													<input type="file" class="custom-file-input" ng2FileSelect
														id="file-upload-single" accept="image/jpeg, image/png, application/pdf"
														(click)="browsbuttonClick('uploadBoand')"
														(change)="onFileChange($event, 'uploadBoand', 25)" />
													<label class="custom-file-label" id="uploadBoand"
														for="file-upload-single">{{bankFormData.boandName.value}}</label>
												</div>
												<div *ngIf="bondDocumentUrl" class="download-file">
													<a href="{{bondDocumentUrl}}" target="_blank"><i
															class="custom-control-inline feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i></a>
												</div>
											</div>
											<div class="form-group col-md-4">
												<label class="form-label" for="mandateform">Upload Mandate form</label>(Upload PDF, image(jpeg or png) of size upto 25MB)
												<div class="custom-file" [ngClass]="{ 'customUploadCls': signedDocumentUrl }">
													<input type="file" class="custom-file-input" ng2FileSelect
														id="file-upload-single" accept="image/jpeg, image/png, application/pdf"
														(click)="browsbuttonClick('mandateform')"
														(change)="onFileChange($event, 'mandateform', 25)" />
													<label class="custom-file-label" id="mandateform"
														for="file-upload-single">{{bankFormData.mandateformName.value}}</label>
												</div>
												<div *ngIf="signedDocumentUrl" class="download-file">
													<a href="{{signedDocumentUrl}}" target="_blank"><i
															class="custom-control-inline feather avatar-icon font-medium-1 icon-arrow-down-circle"
															title="Download Document"></i></a>
												</div>
											</div>
										</div>
									</fieldset>
									<div class="d-flex justify-content-between submitbtn">
										<button class="btn btn-info btn-submit" rippleEffect title="Save Mandate Details"
											(click)="onSave()">Save Mandate Details</button> &nbsp;
										<a href="{{mandateFormURL}}" class="btn btn-secondary btn-submit" rippleEffect
										[ngClass]="{ 'hidden': hasDisabled }" title="Download Mandate form" (click)="showInfo()"
										target="_blank">Download Mandate Form</a> &nbsp;
										<button class="btn btn-success btn-submit" title="Submit" rippleEffect [ngClass]="{ 'hidden': !hasMandateForm }"
											(click)="onSubmit()">Submit</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</div>